import * as React from "react";
import CustomImageGallery from "../../components/postCommunity/CustomImageGallery";
import { s3baseUri } from "../../config/config";
import PostImagesPreview from "../../components/PostImagesComponents/PostImagesPreview";

export default function FeedImagesList({ feed_images, handleClickImage }) {
  let new_gallery = [];
  if (Array.isArray(feed_images) && feed_images?.length > 0) {
    feed_images &&
      feed_images?.map((image) => {
        // new_gallery.push(s3baseUri + image.thumbnail_1);
        new_gallery.push(image);
      });
  }

  return (
    // <CustomImageGallery data={new_gallery} hanldeClick={handleClickImage} />

    <PostImagesPreview
      imagesList={new_gallery}
      openAllImagesModal={handleClickImage}
      isAllImagesClickAble={true}
      maxHeight="600px"
    />
  );
}
